import type { ValidationErrors } from '../../../../../utils/validation';
import type { IDiagnosis } from '../../../../interfaces/diagnosis';
import type { IServiceGetOne } from '../../../../interfaces/serviceGetOne';
import { ConclusieDiagnoseOption } from '../../../../../../common/enums/conclusieDiagnoseOption';
import { nullDiagnosis } from '../../../../../../common/validation/diagnosis';
import { InputRadioGroup } from '../../../../elements/common';
import { FormLabel } from '../../../../elements/forms/FormLabel';
import { HorizontalFormGroup } from '../../../../elements/forms/HorizontalFormGroup';
import { InputContainer } from '../../../../elements/forms/InputContainer';
import { Icd10Selections } from './Icd10/Icd10Selections';

interface IDiagnosisConclusionSelectionProps {
    conclusie_diagnose: ConclusieDiagnoseOption;
    diagnosis: IDiagnosis;
    errors: ValidationErrors;
    handleChangeConclusieDiagnose: (values: { conclusie_diagnose: ConclusieDiagnoseOption }) => Promise<void>;
    handleChangeDiagnosisConsideration: (diagnosis: IDiagnosis) => Promise<void>;
    isRequired?: boolean;
    label?: string;
    service: IServiceGetOne;
    validateConclusieDiagnose: (key: string) => Promise<void>;
    validateDiagnosisConsideration: () => Promise<void>;
}

export function DiagnosisConclusionSelection(props: IDiagnosisConclusionSelectionProps) {
    if (!props.service.specialismCode) {
        return null;
    }

    return (
        <>
            <HorizontalFormGroup hasErrors={props.errors.has('customControlData.conclusie_diagnose')}>
                <FormLabel isRequired={props.isRequired}>
                    {props.label ? props.label : 'Heb je een diagnose?'}
                </FormLabel>
                <InputContainer>
                    <InputRadioGroup
                        automation="conclusie_diagnose"
                        error={props.errors.get('customControlData.conclusie_diagnose')}
                        name="conclusie_diagnose"
                        onChange={async (value) => {
                            await props.handleChangeConclusieDiagnose({ conclusie_diagnose: value });
                            if (value !== ConclusieDiagnoseOption.ja) {
                                await props.handleChangeDiagnosisConsideration({ ...nullDiagnosis });
                            }
                        }}
                        onDoValidate={async () => await props.validateConclusieDiagnose('conclusie_diagnose')}
                        options={[
                            ConclusieDiagnoseOption.ja,
                            ConclusieDiagnoseOption.nog_geen_diagnose,
                            ConclusieDiagnoseOption.geen_afwijkingen,
                        ]}
                        value={props.conclusie_diagnose}
                    />
                </InputContainer>
            </HorizontalFormGroup>

            {props.conclusie_diagnose === ConclusieDiagnoseOption.ja && (
                <Icd10Selections
                    diagnosis={props.diagnosis}
                    errors={props.errors}
                    isRequired
                    isWorkingDiagnosis={false}
                    onChange={async (diagnosis) => await props.handleChangeDiagnosisConsideration(diagnosis)}
                    onDoValidate={async () => await props.validateDiagnosisConsideration()}
                    placeholder="Typ en kies je diagnose"
                    specialismCode={props.service.specialismCode}
                />
            )}
        </>
    );
}
